/**
Section
=======

A `Section` is a list of [beat, staffNote, accidental, instrument] tuples.

It includes a length in beats and a tempo in bpm.

Status: Legacy

*/

{ inRange, quantize } from ./util.civet
import ./extensions.civet

{min, max} := Math

Model from ./model.civet

Section := (I={}, self=new Model(I)) ->
  defaults I,
    keySignature: 0 //[-7, 7]
    length: 64 //beats
    name: "Untitled Section"
    notes: []
    presetName: "purple"
    tempo: 90 //bpm
    timeSignature: "4/4"

  I.keySignature = I.keySignature|0 //Force Int (previous versions had an unused "C")
  I.length = I.length|0 //Force Int

  self.attrObservable "keySignature", "name", "tempo", "notes", "presetName", "timeSignature"

  self.observable "length", (value) ->
    v := parseFloat(value) or 0
    min max(1, v), 9999

  self.extend
    addNote: (note) ->
      self.notes.push(note)

    removeNoteByReference: (note) ->
      index := self.notes.indexOf(note)

      if index >= 0
        return self.notes.splice(index, 1)

    //Remove a note, checking first for the exact match
    //then for a near note. We should be able to erase triplets
    //without having to change the quantization.
    removeNote: ([time, note], nearby) ->
      [..., matched] := self.notes.filter ([t, n]) ->
        note is n and time is t

      if matched
        return self.notes.splice(self.notes.indexOf(matched), 1)

      if nearby
        {at, within} := nearby

        matches := self.notes.filter ([t, n]) ->
          note is n and (-within < t - at < within)

        if matches.length
          matches.sort (a, b) ->
            Math.abs(a[0] - at) - Math.abs(b[0] - at)

          matched := matches[0]
          return self.notes.splice(self.notes.indexOf(matched), 1)

    deleteRange: (range) ->
      self.notes self.notes.filter (beatNote) ->
        !inRange(range, beatNote)

    duration: ->
      self.length() * 60 / self.tempo()

    nonEmptyDuration: ->
      lastBeatTime := self.notes.reduce (lastBeat, note) ->
        Math.max lastBeat, note[0]
      , 0

      quantizedLastBeat := quantize lastBeatTime, 4

      let t
      if quantizedLastBeat <= lastBeatTime
        t = quantizedLastBeat + 4
      else
        t = quantizedLastBeat

      return t * 60 / self.tempo()

    numerator: ->
      parseInt(self.timeSignature()) or 4

    //rescale tempo
    retempo: (s) ->
      self.tempo self.tempo() * s
      self.notes.forEach (n) ->
        n[0] *= s
      self.length self.length() * s

      return self

    //`t` and `dt` are in beats.
    //The handler f is called once with each note in the time slice
    upcomingNotes: (t, dt, f) ->
      return if t + dt < 0
      return if t >= I.length

      self.notes.forEach (note) ->
        beat := note[0]

        if t <= beat < t + dt
          f note

export default Section
